const AgrupaltoTheme = {
    images : {
        loginLogo: "/img/agrupalto/login-logo.png",
        whiteLogo: "/img/agrupalto/white_logo.png",
        favicon: "/img/agrupalto/favicon.ico",
        leftMenuLogo: "/img/agrupalto/logo-only.png",
        headerLogo: "/img/agrupalto/name-only.png",
        pt2020: "/img/agrupalto/pt2020.png",
        touchIconIphone: "/img/touch-icon-iphone.png",
        touchIconIpad:"/img/touch-icon-ipad.png",
        touchIconIphoneRetina: "/img/touch-icon-iphone-retina.png",
        touchIconIpadRetina: "/img/touch-icon-ipad-retina.png",
        appleTouchStartupImage: "/img/apple-touch-startup-image",
        qrcodeLogo: "/img/agrupalto/login-logo.png"
    },
    css: [
        "/themes/agrupalto/agrupalto.css"
    ],
    strings: {
        title: "Agrupalto - MyFarmcontrol"
    }
}

export default AgrupaltoTheme;